import { useMemo, useState } from 'react'
import { useGetStaffsQuery } from '@/core/services/staff'
import { GetStaffsParams } from '@/core/api/staff'

export function useSearchDoctors() {
  const [searchDoctorsParams, setSearchDoctorsParams] = useState<GetStaffsParams>({ query: { surname: '', status: 'MEDECIN' }, options: { limit: 5, skip: 0 } })

  const { data, isLoading: isSearchingDoctors } = useGetStaffsQuery(searchDoctorsParams, { refetchOnMountOrArgChange: true })

  const doctors = useMemo(() => {
    return (
      data?.items.map((staff) => ({
        id: staff._id,
        name: staff.userInfo.name,
        surname: staff.userInfo.surname,
        gender: staff.userInfo.gender || 'I',
        city: staff.contactInfo?.city,
        cps: staff.cps,
        email: staff.email,
      })) ?? []
    )
  }, [data?.items])

  return {
    doctors,
    totalDoctors: data?.totalCount ?? 0,
    isSearchingDoctors,
    setSearchDoctorsParams,
  }
}
